export default "__VITE_ASSET__DFSZbjDs__"